// extracted by mini-css-extract-plugin
module.exports = {"dragDropFile":"styles_dragDropFile__1fP7b1EQW91rbpyZpZB-UU"};